export const RESULTS_PER_PAGE = 30;
export const DEFAULT_PAGE = 1;
export const PAGE_QUERY_PARAM = "page";
export const FRONTEND_BU = "frontend-marketplace";
export const NEXT_BU = "next-marketplace";
